import CasePhysicalAssessmentsContainer from './CasePhysicalAssessmentsContainer';

export default CasePhysicalAssessmentsContainer;
